import type { NuxtLinkProps } from '#app'

import { ROUTES } from '~/scopes/auth/route-names'

function buildSheerIdURl({
  baseSheerIdUrl,
  encryptedUserId,
}: {
  baseSheerIdUrl: string
  encryptedUserId: string
}) {
  const url = new URL(baseSheerIdUrl)
  url.searchParams.append('userid', encryptedUserId)

  return url.href
}

export function buildMilitaryDiscountUrl({
  authenticated,
  baseSheerIdUrl,
  encryptedUserId = 'USER_ID',
}: {
  baseSheerIdUrl: string
  authenticated: boolean
  encryptedUserId?: string
}): NuxtLinkProps['to'] {
  const sheerIdUrl = buildSheerIdURl({
    baseSheerIdUrl,
    encryptedUserId,
  })
  if (authenticated) return sheerIdUrl

  return {
    name: ROUTES.AUTH.LOGIN,
    query: {
      next: sheerIdUrl,
      type: 'external',
      bm_journey: 'military_discount',
    },
  }
}
